import { render, staticRenderFns } from "./MButton.vue?vue&type=template&id=cb674dc8&"
import script from "./MButton.vue?vue&type=script&lang=js&"
export * from "./MButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports